import { BROWSER_PATTERNS, OS_PATTERNS } from '../config';

type ParsedUserAgent = {
  browser?: string;
  os?: string;
};

export const parseUserAgent = (userAgent: string): ParsedUserAgent => ({
  browser: BROWSER_PATTERNS.find(({ pattern }) => pattern.test(userAgent))
    ?.name,
  os: OS_PATTERNS.find(({ pattern }) => pattern.test(userAgent))?.name,
});
